import { getToken } from '@helpscout/hsds-tokens/getToken'
import styled from 'styled-components'

import ButtonIcon from 'hsds/components/button-icon'
import { defaultAnimation as overlayAnimation } from 'hsds/hooks'

export const CloseModalButtonUI = styled(ButtonIcon)`
  && {
    position: absolute;
    top: 11px;
    right: 16px;
    z-index: 5;
  }
`

export const SimpleModalOverlayUI = styled('div')`
  --hsds-simpleModal-overlay-z-index: ${getToken('zindex.modal')};
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${getToken('simpleModal.color.background.overlay')};
  background-color: color-mix(
    in srgb,
    ${getToken('simpleModal.color.background.overlay')} 72%,
    transparent
  );
  z-index: var(--hsds-simpleModal-overlay-z-index);
  ${overlayAnimation}

  &.is-fullscreen {
    position: fixed;
  }
`

export const SimpleModalUI = styled('div')`
  --hsds-simpleModal-height: 390px;
  --hsds-simpleModal-width: 360px;
  --hsds-simpleModal-background-color: ${getToken(
    'simpleModal.color.background.body'
  )};
  position: relative;
  width: var(--hsds-simpleModal-width);
  height: var(--hsds-simpleModal-height);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--hsds-simpleModal-background-color);
  border-radius: ${getToken('radius.bubble')};
  box-shadow: ${getToken('shadow.700')};

  &.cleared-dimensions {
    --hsds-simpleModal-width: unset;
    --hsds-simpleModal-height: unset;
  }

  &:focus-visible {
    --focus-outer-color: ${getToken('simpleModal.color.focus.outer')};
    --focus-inner-color: ${getToken('simpleModal.color.focus.inner')};
    --focus-inner-color: color-mix(
      in srgb,
      ${getToken('simpleModal.color.focus.inner')} 50%,
      transparent
    );
    box-shadow: 0 0 0 3px var(--focus-outer-color),
      0 0 0 5px var(--focus-inner-color), ${getToken('shadow.700')};
    outline: 0;
  }
`
